import WhatWeOfferPage from './WhatWeOfferPage';

export default WhatWeOfferPage;
